import { BRICK_COLORS as C } from "../bricks/palette";
import type { Plan, PlanBrick } from "./types";

/**
 * Original microscale plans on a stud grid (LDraw-style, CC0).
 * Homages to classic first-builds — not official LEGO set copies.
 */
function p(
  w: number,
  d: number,
  x: number,
  z: number,
  layer: number,
  color: number,
): PlanBrick {
  return { w, d, x, z, layer, color };
}

export const PLANS: Plan[] = [
  {
    id: "duck",
    name: "Duck",
    blurb: "Classic first build",
    bricks: [
      p(4, 2, 0, 0, 0, C.yellow),
      p(2, 2, -1, 0, 1, C.yellow),
      p(2, 2, 1, 0, 1, C.yellow),
      p(2, 2, 1, 0, 2, C.yellow),
      p(2, 2, 1.5, 0, 3, C.yellow),
      p(1, 1, 2.8, 0, 3, C.orange),
      p(1, 1, 1.2, 0.6, 4, C.black),
    ],
  },
  {
    id: "racer",
    name: "Racer",
    blurb: "Red sports microcar",
    bricks: [
      p(1, 2, -2.5, 0, 0, C.black),
      p(1, 2, 2.5, 0, 0, C.black),
      p(4, 2, 0, 0, 1, C.brightRed),
      p(2, 2, -1, 0, 2, C.brightRed),
      p(2, 2, 1, 0, 2, C.white),
      p(1, 2, 2.5, 1, 1, C.cyan),
      p(1, 2, 2.5, -1, 1, C.cyan),
      p(2, 1, 0, 0, 3, C.black),
    ],
  },
  {
    id: "cottage",
    name: "Cottage",
    blurb: "Red-roof micro house",
    bricks: [
      p(4, 4, 0, 0, 0, C.green),
      p(4, 2, 0, 0, 1, C.white),
      p(2, 2, -1, 0, 2, C.white),
      p(2, 2, 1, 0, 2, C.white),
      p(1, 1, 1.5, 0.6, 2, C.cyan),
      p(4, 2, 0, 0, 3, C.brightRed),
      p(2, 2, 0, 0, 4, C.brightRed),
      p(1, 1, 0, 0, 5, C.orange),
    ],
  },
  {
    id: "starfighter",
    name: "Fighter",
    blurb: "Arena starfighter",
    bricks: [
      p(2, 2, 0, 0, 0, C.white),
      p(4, 1, 0, 0, 1, C.white),
      p(2, 1, 0, 0, 2, C.cyan),
      p(3, 1, -2.5, 1.2, 1, C.white),
      p(3, 1, -2.5, -1.2, 1, C.white),
      p(2, 1, 2, 0, 1, C.brightRed),
      p(1, 1, 3.2, 0, 1, C.orange),
      p(1, 1, 0, 0, 3, C.lime),
    ],
  },
  {
    id: "tree",
    name: "Grove",
    blurb: "Two-tone brick tree",
    bricks: [
      p(2, 2, 0, 0, 0, C.green),
      p(1, 1, 0, 0, 1, C.orange),
      p(1, 1, 0, 0, 2, C.orange),
      p(3, 2, 0, 0, 3, C.green),
      p(2, 2, 0, 0, 4, C.lime),
      p(2, 1, 0, 0, 5, C.green),
      p(1, 1, 0, 0, 6, C.lime),
    ],
  },
  {
    id: "mech",
    name: "Mech",
    blurb: "Chunky arena bot",
    bricks: [
      p(1, 1, -1, 0.6, 0, C.darkBlue),
      p(1, 1, 1, 0.6, 0, C.darkBlue),
      p(3, 2, 0, 0, 1, C.blue),
      p(2, 2, 0, 0, 2, C.cyan),
      p(2, 2, 0, 0, 3, C.yellow),
      p(1, 1, -1.6, 0, 2, C.brightRed),
      p(1, 1, 1.6, 0, 2, C.brightRed),
      p(1, 1, -0.4, 0.4, 4, C.black),
      p(1, 1, 0.4, 0.4, 4, C.black),
    ],
  },
  {
    id: "keep",
    name: "Keep",
    blurb: "Micro castle",
    bricks: [
      p(4, 4, 0, 0, 0, C.green),
      p(4, 2, 0, 0, 1, C.darkBlue),
      p(1, 1, -1.5, -0.8, 2, C.darkBlue),
      p(1, 1, 1.5, -0.8, 2, C.darkBlue),
      p(1, 1, -1.5, 0.8, 2, C.darkBlue),
      p(1, 1, 1.5, 0.8, 2, C.darkBlue),
      p(2, 2, 0, 0, 2, C.blue),
      p(2, 1, 0, 0, 3, C.brightRed),
      p(1, 1, 0, 0, 4, C.yellow),
    ],
  },
  {
    id: "boat",
    name: "Cruiser",
    blurb: "Tiny sailboat",
    bricks: [
      p(4, 2, 0, 0, 0, C.blue),
      p(3, 2, 0, 0, 1, C.white),
      p(1, 1, 0, 0, 2, C.orange),
      p(1, 1, 0, 0, 3, C.orange),
      p(1, 1, 0, 0, 4, C.orange),
      p(2, 1, 1, 0, 3, C.white),
      p(1, 1, -1.6, 0, 2, C.cyan),
    ],
  },
];

export function planById(id: string): Plan | undefined {
  return PLANS.find((p) => p.id === id);
}
